import axios from 'axios'
import { useQuery } from '@tanstack/react-query'
import { BoatsLocationsResponseSchema } from '../models/boat'

const getBoatLocations = async (
  boatId: number,
  startDate: Date,
  endDate: Date
) => {
  const start = startDate.toISOString().split('T')[0]
  const end = endDate.toISOString().split('T')[0]

  const res = await axios.get('/api/boats/locations', {
    params: {
      boat_id: boatId,
      start,
      end,
    },
  })
  return BoatsLocationsResponseSchema.parse(res.data)
}

export const useBoatLocations = (
  boatId: number,
  startDate: Date,
  endDate: Date
) => {
  return useQuery({
    queryKey: ['boat-locations', boatId, startDate, endDate],
    queryFn: () => getBoatLocations(boatId, startDate, endDate),
    enabled: !!boatId && !!startDate && !!endDate,
    staleTime: 60 * 1000, // 1 minute
  })
}
